import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';

import StatCard from 'ui/StatCard/StatCard'
import { formatPrice } from 'utils/rewards';

const OrderStats = ({ orders }) => {

  const order = orders?.[0];

  const stat1 = order ? formatPrice(order.net_value_sum, order.currency, true) : 0
  const stat2 = order ? formatPrice(order.application_fee_sum, order.currency, true) : 0
  const stat3 = order ? formatPrice(order.total_value_sum, order.currency, true) : 0

  // Unrounded values for tooltips
  const unroundedStat1 = order ? formatPrice(order.net_value_sum, order.currency, false) : 0
  const unroundedStat2 = order ? formatPrice(order.application_fee_sum, order.currency, false) : 0
  const unroundedStat3 = order ? formatPrice(order.total_value_sum, order.currency, false) : 0

  return (
    <div className="ui-stats-grid">
      
      <Tooltip title={unroundedStat1} arrow>
        <div>
          <StatCard 
            type='number'
            highlight={stat1}
            title='Net Value' />
        </div>
      </Tooltip>

      <Tooltip title={unroundedStat2} arrow>
        <div>
          <StatCard 
            type='number'
            highlight={stat2}
            title='Service Fees' />
        </div>
      </Tooltip>

      <Tooltip title={unroundedStat3} arrow>
        <div>
          <StatCard 
            type='number'
            highlight={stat3}
            title='Total Value' />
        </div>
      </Tooltip>

    </div>
  )
};

OrderStats.propTypes = {
  orders: PropTypes.array
};

export default OrderStats;